// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3npHi","name":"styles_name__3HWjG","phone":"styles_phone__TzBZ9"};